<template>
	<div class="kc-maincontainer">
		<div
			style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
			v-if="LoaderStatus"
		>
			<Spinner />
		</div>
		<div class="keylogincontainer">
			<div class="keyheading d-flex align-items-center">
				<h1>Sign in to your account</h1>
			</div>
			<div class="mainlog mb-5">
				<div class="keyname">
					<div class="topDiv mt-3">
						<label class="keylabel">Email &nbsp;</label>
						<b-form-input
							class="labelbox"
							id="input-1"
							placeholder="Enter here"
							autofocus
							type="text"
							v-model.trim="$v.username.$model"
							@keyup="convertToLowerCase"
							@input="convertToLowerCase"
							:class="{ error: $v.username.$error }"
							v-on:keyup.enter="onEnter"
						></b-form-input>
						<div
							class="validationiconlogin"
							v-if="$v.username.$dirty && !$v.username.required"
							v-b-popover.hover.top.v-danger="{ content: 'Required' }"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
						<div
							class="validationiconlogin"
							v-if="!$v.username.maxLength"
							v-b-popover.hover.top.v-danger="{
								content: `cannot enter more than 64 characters`,
							}"
							variant="primary"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
						<div
							class="validationiconlogin"
							v-if="!$v.username.email"
							v-b-popover.hover.top.v-danger="{
								content: 'Email is invalid',
							}"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
					</div>
				</div>
				<div class="keypassword">
					<div class="topDiv mt-3">
						<label class="keylabel">Password &nbsp;</label>
						<b-form-input
							class="labelbox"
							placeholder="Enter here"
							type="text"
							v-if="showPassword"
							v-model.trim="$v.password.$model"
							:class="{ error: $v.password.$error }"
							v-on:keyup.enter="onEnter"
						>
						</b-form-input>
						<b-form-input
							class="labelbox"
							placeholder="Enter here"
							type="password"
							v-else
							v-model.trim="$v.password.$model"
							:class="{ error: $v.password.$error }"
							v-on:keyup.enter="onEnter"
						>
						</b-form-input>
						<div
							class="validationdropdown"
							v-if="$v.password.$dirty && !$v.password.required"
							v-b-popover.hover.top.v-danger="{ content: 'Required' }"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>

						<div
							class="keyimage pointer"
							v-if="showPassword"
							@click="toggleShow"
						>
							<img src="../../assets/notviewicon.svg" alt="" />
						</div>
						<div
							class="keyimage pointer"
							v-if="!showPassword"
							@click="toggleShow"
						>
							<img src="../../assets/eyeicon.svg" alt="" />
						</div>
					</div>
				</div>
				<div class="d-flex">
					<div id="message"></div>
					<router-link to="/forgot">
						<div class="forgot">Forgot password?</div>
					</router-link>
				</div>
			</div>

			<div class="text-center">
				<b-button @click="validateuser" class="addbtn pr-3 pl-3 mt-5"
					>SIGN IN</b-button
				>
			</div>
		</div>
	</div>
</template>

<script>
import errorToast from "../mixin/toast";
import { required, email, maxLength } from "vuelidate/lib/validators";
import { mapMutations } from "vuex";
const qs = require("qs");
import { removeToken } from "../../utils/tokenCheck";
import Spinner from "../../components/fixedcomponents/Spinner.vue";

export default {
	name: "keycloaklogin",
	components: {
		Spinner,
	},
	mixins: [errorToast],
	data() {
		return {
			username: "",
			password: "",
			showPassword: false,
			accesstoken: "",
			LoaderStatus: false,
			// refreshtoken: "",
		};
	},
	computed: {
		buttonLabel() {
			return this.showPassword ? "Hide" : "Show";
		},
	},
	validations: {
		username: {
			required,
			email,
			maxLength: maxLength(64),
		},
		password: {
			required,
		},
	},
	methods: {
		...mapMutations({
			setToken: "userVUEX/SET_TOKEN",
			setRefreshToken: "userVUEX/SET_REFRESH_TOKEN",
		}),
		toggleShow() {
			this.showPassword = !this.showPassword;
		},
		onEnter() {
			this.validateuser();
		},
		validateuser() {
			this.$v.$touch();
			this.LoaderStatus = true;
			if (!this.$v.$invalid) {
				let username = this.username.trim();
				let password = this.password;
				let userDetails = {
					keycloak: qs.stringify({
						grant_type: "password",
						client_id: "vue-test-app",
						username: username,
						password: password,
					}),
					username: this.username,
				};
				this.$store
					.dispatch("userVUEX/Login", userDetails)
					.then((res) => {
						if (res.status == 200) {
							this.$store
								.dispatch("userVUEX/getUserData", "login")
								.then((res) => {
									const { landingPage } = res;
									this.$router.push(landingPage);
								})
								.catch((err) => {
									this.LoaderStatus = false;
									this.errorToast("You Don't have access");
									this.setToken("");
									this.setRefreshToken("");
									removeToken();
									throw err;
								});
						}
					})
					.catch((err) => {
						if (err.response.status == 401) {
							this.LoaderStatus = false;
							document.getElementById(
								"message"
							).innerHTML = `${err.response.data.error_description}`;
						}
					});
			} else {
				document.getElementById("message").innerHTML = "";
				this.LoaderStatus = false;
			}
		},
		// Converting text to lowercase
		convertToLowerCase() {
			this.username = this.username.toLowerCase();
		},
	},
};
</script>

<style>
#message {
	color: red;
	font-weight: 400;
	font-size: 14px;
	line-height: 21px;
	margin-top: 10px;
}
.kc-maincontainer {
	height: 100vh;
	background: url("../../assets/keycloakbg.png") no-repeat center center fixed;
	-webkit-background-size: cover;
	-moz-background-size: cover;
	-o-background-size: cover;
	background-size: cover;
	position: relative;
	display: flex;
	place-content: center;
	place-items: center;
}
.keylogincontainer {
	position: absolute;
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	padding: 35px 95px;
}
.keyheading {
	font-weight: 600;
	font-size: 25px;
	line-height: 38px;
	/* identical to box height */
	color: #72738e;
}
.labelbox {
	border-radius: 3px !important;
	background: #fdfdfd;
	border: 0.7px solid rgba(114, 115, 142, 0.7);
	box-sizing: border-box;
	box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.25);
	padding-left: 6px;
	font-size: 16px !important;
}
.keyname {
	margin-top: 74px;
}
.keypassword {
	margin-top: 45px;
}
.keylabel {
	background-color: var(--bg-inputfield);
	position: absolute;
	left: 0.5vw;
	top: -9px;
	font-weight: 500;
	font-size: 12px;
	/* identical to box height */
	color: #72738e;
	line-height: 18px;
	z-index: 5;
	padding-left: 6px;
	padding-right: 4px;
}
.forgot {
	position: absolute;
	margin-top: 10px;
	right: 94px;
	font-weight: 500;
	font-size: 14px;
	line-height: 21px;
	/* identical to box height */
	color: #3f698e;
}

.newuser {
	margin-top: 30px;
	text-align: center;
	color: #72738e;
	font-weight: 500;
	font-size: 14px;
	line-height: 21px;
}
.reg {
	margin-top: 30px;
	text-align: center;
	font-weight: 500;
	font-size: 14px;
	line-height: 21px;
	color: #3f698e;
}
.keyimage {
	position: absolute;
	top: 5px;
	right: 10px;
}
.keyimage img {
	width: 16px;
}
.mainlog .form-control:focus {
	box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.25) !important;
	font-size: 16px !important;
}
.validationdropdown {
	position: absolute;
	top: 5px;
	right: 30px;
}
.validationiconlogin {
	position: absolute;
	top: 3px;
	right: 12px;
}
</style>
